<script>
import { Line } from 'vue-chartjs'

export default {
  name:"lineBig",
  extends: Line,
  props: [
    'chartdata',
    ],
  data(){
    
    return {
        myStyles: {
            height:'368px',
            width: '100%',
            position: 'relative',
          },      
          options: {
            responsive: true,
            maintainAspectRatio: false,
            
            legend: {
              display: false,
              labels: {
                      // fontSize: 0,
                      fontColor: 'green'
                  }              
            },
            scales: {
              xAxes: [{
                ticks: {
                    // display: false
                },
                gridLines: {
                    // display:false
                }
              }],
              yAxes: [{
                position: 'right',
                ticks: {
                  stepSize: 100,
                  min: 0,
                  max: 300
                },
                gridLines: {
                    // display:false
                }
              }]              
            }            
          }
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
</script>

<style>
</style>